export const chatBarItemWidth = 420;
